var $ = require("jquery");

$(".site-component-preview form").on("submit", (e) => {
  e.preventDefault;
  return false;
});
